import type { ComponentType } from 'react';
import Component from './StatsSection';
import Container, { OwnProps } from './StatsSection.container';

export default Container(Component) as ComponentType<OwnProps>;
